import _ from 'underscore';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';

function customDateRangeFormatter(i18n) {
  const formatter = i18n.dateFormatter({ skeleton: 'yMd' });
  const parser = i18n.dateParser({ raw: 'yyyy-MM-dd' });

  const formatDate = _.compose(formatter, parser, str => str.substr(0, 10));
  return (start, end) => `${formatDate(start)} - ${formatDate(end)}`;
}

export class DateRangeFormat {
  constructor({
    i18n,
  }) {
    this.s$i18n = new SchemaI18n({ i18n });
    this.i18n = i18n;
    this.formatCustomDateRange = customDateRangeFormatter(i18n);
  }

  format(dateRange) {
    if (!dateRange) {
      return this.i18n.getString('None');
    }

    const {
      DateRangePreset,
      StartDate,
      EndDate,
    } = dateRange;

    if (DateRangePreset) {
      return this.formatPreset(DateRangePreset);
    }

    return this.formatCustomDateRange(StartDate, EndDate);
  }

  formatPreset(preset) {
    return preset ?
      this.s$i18n.enum('DateRangePreset', preset) :
      this.i18n.getString('Custom');
  }
}

export class ComparisonDateRangeFormat {
  constructor({
    i18n,
    noneStringKey = 'None',
  }) {
    this.s$i18n = new SchemaI18n({ i18n });
    this.i18n = i18n;
    this.formatCustomDateRange = customDateRangeFormatter(i18n);
    this.noneStringKey = noneStringKey;
  }

  format(comparisonDateRange) {
    if (!comparisonDateRange) {
      return this.i18n.getString(this.noneStringKey);
    }

    const {
      ComparisonDateRangeOption,
      StartDate,
      EndDate,
    } = comparisonDateRange;

    if (ComparisonDateRangeOption) {
      return this.s$i18n.enum('ComparisonDateRangeOption', ComparisonDateRangeOption);
    }

    return this.formatCustomDateRange(StartDate, EndDate);
  }

  formatPreset(preset) {
    if (preset) {
      if (preset === 'None') {
        return this.i18n.getString(this.noneStringKey);
      }
      return this.s$i18n.enum('ComparisonDateRangeOption', preset);
    }
    return this.i18n.getString('Custom');
  }
}
